import type { ReactElement } from 'react';
import { HeroRule } from '../shell';

/** Shown while the first route's code loads: the gradient rule flowing, nothing else. */
export function AppLoading(): ReactElement {
  return (
    <div aria-busy="true">
      <HeroRule busy />
    </div>
  );
}
